import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

interface Props {
  width?: number;
  height?: number;
  src: string;
  alt?: string;
  marginRight?: boolean;
  cursor?: string;
  marginLeft?: number;
  rotate?: number;
  disabled?: boolean;
  lazy?: boolean;
  [x: string]: any;
}

function IconImg({
  width = 24,
  height = 24,
  src,
  alt = '',
  marginRight = false,
  marginLeft = 0,
  cursor,
  rotate,
  disabled = false,
  lazy = false,
  ...props
}: Props) {
  return (
    <Img
      loading={lazy ? 'lazy' : undefined}
      marginRight={marginRight}
      marginLeft={marginLeft}
      width={width}
      height={height}
      src={src}
      alt={alt}
      cursor={cursor}
      rotate={rotate}
      disabled={disabled}
      {...props}
    />
  );
}

interface ImgProps {
  marginRight: any;
  marginLeft: number;
  width?: number;
  height?: number;
  cursor?: string;
  rotate?: number;
  disabled?: boolean;
}

const Img: any = styled.img`
  margin-right: ${(props: ImgProps) => (props.marginRight ? rem(16) : 0)};
  margin-left: ${(props: ImgProps) => rem(props.marginLeft)};
  width: ${(props: ImgProps) => (props.width ? rem(props.width) : 'initial')};
  height: ${(props: ImgProps) =>
    props.height ? rem(props.height) : 'initial'};
  cursor: ${(props: ImgProps) => (props.cursor ? props.cursor : 'initial')};
  transform: ${(props: ImgProps) =>
    props.rotate ? `rotate(${props.rotate}deg)` : ''};
  transition: transform 0.3s ease;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
`;

export { IconImg };
